/**
 * RGB color type
 */
export type RGB = [number, number, number];
